import { AppRoutes } from '../../constants/appRoutes';
import { entityNames } from '../../constants/entities';
import { EDetailsQueryNames } from '../../constants/queryNames';
import { Requirement } from '../../models/stack9/Requirement';
import { EntityDrawer } from '../EntityDrawer/EntityDrawer';

type RequirementDrawerProps = {
  open: boolean;
  onClose: () => void;
  id?: number;
  initialValues?: Partial<Requirement>;
};

export const RequirementDrawer = ({
  open,
  onClose,
  id,
  initialValues,
}: RequirementDrawerProps) => {
  const formFields = [
    { field: 'code', isRequired: false, isReadOnly: true, colSize: 8 },
    { field: 'question_type', colSize: 8 },
    { field: 'sequence', colSize: 8 },
    { field: 'requirement_section_id' },
    { field: 'base_requirement_id' },
    { field: 'question' },
    { field: 'required_document_types' },
    { field: 'allow_text_area', colSize: 8 },
    { field: 'is_mandatory', colSize: 8 },
    { field: 'preserve_for_renewal', colSize: 8 },
    { field: 'is_active' },
  ];

  return (
    <EntityDrawer
      title="requirement"
      formFields={formFields}
      initialValues={initialValues}
      id={id}
      open={open}
      onClose={onClose}
      screenQueryName={EDetailsQueryNames.GetRequirementDetails}
      entityName={entityNames.REQUIREMENT}
      editRoute={AppRoutes.RequirementDetail}
      relativePath={AppRoutes.CountryTemplateDetail}
    />
  );
};
